export enum PostDetailTableColumnsEnum {
    Source = 'source',
    Name = 'name',
    Status = 'status',
    Link = 'link',
}
